import { goalSettingsActionTypes } from '@/pages/goalSettings/Constants';

export function getGoalSettingsRequest() {
	return {
		type: goalSettingsActionTypes.GET_GOAL_SETTINGS_REQUEST,
	};
}

export function getGoalSettingsSuccess(data: any) {
	return {
		type: goalSettingsActionTypes.GET_GOAL_SETTINGS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getGoalSettingsError() {
	return {
		type: goalSettingsActionTypes.GET_GOAL_SETTINGS_ERROR,
		error: true,
	};
}

export function getGoalDurationsRequest() {
	return {
		type: goalSettingsActionTypes.GET_GOAL_DURATIONS_REQUEST,
	};
}

export function getGoalDurationsSuccess(durations: any) {
	return {
		type: goalSettingsActionTypes.GET_GOAL_DURATIONS_SUCCESS,
		payload: {
			durations,
		},
	};
}

export function getGoalDurationsError() {
	return {
		type: goalSettingsActionTypes.GET_GOAL_DURATIONS_ERROR,
		error: true,
	};
}

export function setSelectedSubject(subjectId: number, selected: boolean) {
	return {
		type: goalSettingsActionTypes.SET_SELECTED_SUBJECT,
		payload: {
			subjectId,
			selected,
		},
	};
}

export function setSelectedCategory(subjectId: number, categoryId: number, selected: boolean) {
	return {
		type: goalSettingsActionTypes.SET_SELECTED_CATEGORY,
		payload: {
			subjectId,
			categoryId,
			selected,
		},
	};
}

export function setSelectedSubcategory(
	subjectId: number,
	categoryId: number,
	subcategoryId: number,
	selected: boolean,
) {
	return {
		type: goalSettingsActionTypes.SET_SELECTED_SUBCATEGORY,
		payload: {
			subjectId,
			categoryId,
			subcategoryId,
			selected,
		},
	};
}

export function setSelectedDuration(duration: any) {
	return {
		type: goalSettingsActionTypes.SET_SELECTED_DURATION,
		payload: {
			duration,
		},
	};
}

export function setCurrentProgress(progress: number) {
	return {
		type: goalSettingsActionTypes.SET_CURRENT_PROGRESS,
		payload: {
			progress,
		},
	};
}

export function saveGoalSettingsRequest(
	playDaysPerWeek: number,
	durationId: number,
	subjects: any[],
) {
	return {
		type: goalSettingsActionTypes.SAVE_GOAL_SETTING_REQUEST,
		payload: {
			playDaysPerWeek,
			durationId,
			subjects,
		},
	};
}

export function saveGoalSettingsSuccess() {
	return {
		type: goalSettingsActionTypes.SAVE_GOAL_SETTING_SUCCESS,
	};
}

export function saveGoalSettingsError() {
	return {
		type: goalSettingsActionTypes.SAVE_GOAL_SETTING_ERROR,
	};
}

export function toggleUnsavedChangesModal(data: any) {
	return {
		type: goalSettingsActionTypes.TOGGLE_UNSAVED_CHANGES_MODAL,
		payload: {
			data,
		},
	};
}

export function setPlayDaysPerWeek(playDaysPerWeek: number) {
	return {
		type: goalSettingsActionTypes.SET_PLAY_DAYS_PER_WEEK,
		payload: {
			playDaysPerWeek,
		},
	};
}

export function getCurrentPracticeRequest() {
	return {
		type: goalSettingsActionTypes.GET_CURRENT_PRACTICE_REQUEST,
	};
}

export function getCurrentPracticeSuccess(playDaysPerWeek: number) {
	return {
		type: goalSettingsActionTypes.GET_CURRENT_PRACTICE_SUCCESS,
		payload: {
			playDaysPerWeek,
		},
	};
}

export function getCurrentPracticeError() {
	return {
		type: goalSettingsActionTypes.GET_CURRENT_PRACTICE_ERROR,
		error: true,
	};
}

export function setPlayMode(playMode: string | null) {
	return {
		type: goalSettingsActionTypes.SET_PLAY_MODE,
		payload: {
			playMode,
		},
	};
}

export function setActiveEditTarget(step: string | null, subStep?: string | number | null) {
	return {
		type: goalSettingsActionTypes.SET_ACTIVE_EDIT_TARGET,
		payload: {
			step: step ?? null,
			subStep: subStep ?? null,
		},
	};
}

export function resetSubjectsToInitial() {
	return {
		type: goalSettingsActionTypes.RESET_SUBJECTS_TO_INITIAL,
	};
}

export function resetPracticeToInitial() {
	return {
		type: goalSettingsActionTypes.RESET_PRACTICE_TO_INITIAL,
	};
}

export function resetPlayModeToInitial() {
	return {
		type: goalSettingsActionTypes.RESET_PLAY_MODE_TO_INITIAL,
	};
}
